import { Component } from '@angular/core';

@Component({
  selector: 'rr-card-content',
  standalone: false,

  templateUrl: './card-content.component.html',
  styleUrl: './card-content.component.scss'
})
export class CardContentComponent {

}
